import { Palette, BarChart3, Video, Share2, Megaphone, Brush, FileText, TrendingUp } from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  { icon: Palette, title: "Graphic Designing", slug: "graphic-designing", desc: "Professional logo design, social media posts, ad creatives, flyers, brand identity kits, banners, infographics, and packaging designs." },
  { icon: BarChart3, title: "Digital Marketing", slug: "digital-marketing", desc: "Content strategy, paid ads campaigns, influencer marketing, analytics & reporting, brand awareness, and growth strategies." },
  { icon: Video, title: "Video Editing", slug: "video-editing", desc: "Promotional videos, social media clips, corporate videos, YouTube editing, motion graphics, and ad video creatives." },
  { icon: Share2, title: "Social Media Management", slug: "social-media", desc: "Daily posting, community engagement, content calendars, audience growth, and platform management across all channels." },
  { icon: Megaphone, title: "Ads Management", slug: "ads-management", desc: "Facebook, Instagram, and LinkedIn ads with measurable ROI, audience targeting, A/B testing, and campaign optimization." },
  { icon: Brush, title: "Branding", slug: "branding", desc: "Complete brand identity packages including color palettes, fonts, style guides, and visual storytelling that defines your brand." },
  { icon: FileText, title: "Content Creation", slug: "content-creation", desc: "Engaging content for websites, social media, blogs, and marketing campaigns that drives traffic and conversions." },
  { icon: TrendingUp, title: "Marketing Strategy", slug: "marketing-strategy", desc: "Data-driven marketing strategies combining branding, ads, social media, and content to reach the right audience." },
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-12 md:py-20">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="inline-block px-5 py-2 rounded-full gradient-cta text-primary-foreground text-xs font-semibold tracking-widest uppercase mb-4">Our Services</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-foreground mb-4">
            Our Digital Marketing Services
          </h2>
          <p className="text-muted-foreground text-sm md:text-base">
            Complete creative and digital solutions to grow your brand online.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {services.map((s) => (
            <Link
              to={`/services/${s.slug}`}
              key={s.slug}
              className="group bg-card rounded-2xl border border-border p-4 md:p-6 hover:shadow-xl hover:-translate-y-1 transition-all duration-200 flex flex-col h-full"
            >
              <div className="w-10 h-10 md:w-14 md:h-14 rounded-xl md:rounded-2xl gradient-hero flex items-center justify-center mb-3 md:mb-5">
                <s.icon className="w-5 h-5 md:w-6 md:h-6 text-primary-foreground" />
              </div>
              <h3 className="text-sm md:text-lg font-bold text-card-foreground mb-2 md:mb-3">{s.title}</h3>
              <p className="text-xs md:text-sm text-muted-foreground leading-relaxed mb-3 md:mb-4 flex-1 hidden sm:block">{s.desc}</p>
              <span className="text-xs md:text-sm font-semibold text-primary group-hover:underline">
                Read More →
              </span>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10">
          <Link to="/services" className="inline-flex px-6 py-3 rounded-full border-2 border-primary text-primary font-display font-semibold text-sm hover:bg-primary hover:text-primary-foreground transition-colors">
            See All Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
